exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-view-list[data-v-0c72699a] {\n  color: white !important;\n  background-color: #14b1af !important;\n}\n.inactive-background[data-v-0c72699a] {\n  background: #bfbfbf;\n}\n.custom-checkbox.check_current_checkbox[data-v-0c72699a] {\n  margin-left: 7px !important;\n}\n.custom-checkbox.check_current_checkbox2[data-v-0c72699a] {\n  margin-left: 16px !important;\n}\n.custom-control-input:checked ~ .custom-control-label[data-v-0c72699a]::before {\n  color: #fff !important;\n  background-color: #0068f8 !important;\n  border-color: #0068f8 !important;\n}\n", ""]);

// exports
